// extracted by mini-css-extract-plugin
export var logo = "_c8-2";
export var logoWrapper = "_c8-1";
export var strip = "_c8-0";